<template>
  <div>
    <div>
      <ckeditor
          ref="editor"
          :editor="editor"
          :config="editorConfig"
          @ready="onReady"
          v-model="template"
          :disabled="disabled"
          @input="$emit('input', template)"
      ></ckeditor>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Variable from "./Variable";

export default {
  name: "Editor",
  components: {ckeditor: CKEditor.component},
  props: ['value', 'lang', 'disabled', 'toolbarDisabled'],
  data() {
    return {
      template: this.value,
      editor: ClassicEditor,
      variableText: this.$t('pages.template_builder.show_variables'),
      editorConfig: {
        fontSize: {
          options: [
            9,
            11,
            13,
            'default',
            17,
            19,
            21
          ]
        },
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          ParagraphPlugin,
          Underline,
          ListStyle,
          Clipboard,
          RemoveFormat,
          Variable,
          Font
        ],
        language: this.lang,
        toolbar: ['bold', 'italic', 'underline', 'fontSize', 'removeFormat', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo', 'variable'],
      }
    }
  },
  methods: {
    openVariableModal() {
      this.$emit('open')
    },
    onReady(editor) {
      this.$emit('editorInstances', editor)
    },
  },
  watch: {
    toolbarDisabled(val) {
      if (this.instance) {
        for (let i = 0; i < 13; i++) {
          this.instance.ui.view.toolbar.items.get(i).isEnabled = val === 'customEmail'
        }
      }
    }
  },
  mounted() {
    window.vue = this;
  }
}
</script>
<style scoped>
/deep/ .ck.ck-toolbar .ck.ck-toolbar__separator, .mce-container {
  margin-left: 6px;
  margin-right: 6px;
  background-color: #c4c4c4 !important;
}

/deep/ .variable-btn {
  border-color: #c4c4c4;
}

/deep/ .ck-button_with-text .ck.ck-button__label {
  margin-left: 3px !important;
  margin-top: 3px !important;
}
</style>